import FilterRegister from "../../../../components/filter/register-basic";
import reqBoletoConfig from "../../../../services/reqMultiTenant/reqBoletoConfig";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterBoletoConfig = () => {
	const options = {
		id: "id_boleto_config",
		ident: "boletoConfigRegister",
		identFilter: "filterBoletoConfig",
		title: "Convênio de Boleto",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "descricao", label: "Convênio", align: "left" },
			{ key: "banco", label: "Banco", align: "left" },
			{ key: "convenio", label: "Nº Convênio", align: "left" },
			{ key: "agencia", label: "Agência", align: "left" },
			{ key: "conta", label: "Conta", align: "left" },
			{ key: "carteira", label: "Carteira", align: "center" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: false,
		parametersFilter: [
			{ id: 1, label: "Nome do Convênio", value: "descricao" },
			{ id: 2, label: "Nº do Convênio", value: "convenio" },
		],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData;

		const response = await reqBoletoConfig.listPaginate(param, paramValue, active, newPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqBoletoConfig.listID(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqBoletoConfig.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterBoletoConfig;
